/**
 * 接口文档
 * http://192.168.3.101/webot-dev/webot3/blob/xuwei/doc/api/H5.md#%E8%AF%84%E4%BB%B7-post-chatcomment
 */

import request from '@/utils/request'

/**
 * 提交评价
 * @param { Number } chatServiceId
 * @param { Number } startNum
 * @param { String } suggestion
 */
export function postEvaluation (chatServiceId, starNum, suggestion) {
    return request({
        url: 'chat/comment',
        method: 'post',
        data: {
            chat_service_id: chatServiceId,
            satisfaction: starNum,
            satisfaction_describe: suggestion
        }
    })
}
